import React, { useEffect } from 'react';
import { ErrorWithContext } from '@atlassian/people-teams';
import { renderPeopleNavMenuExp } from '../analytics/experiences';
export const ICON_SIZE = 32;
export const MAX_POPUP_WIDTH = 480;
export const MIN_POPUP_WIDTH = 320;
// this max-height is copied from Confluence's styles.
export const MAX_POPUP_HEIGHT = 'calc(100vh - 79px)';
export function ImgIcon({
  src,
  alt
}) {
  return /*#__PURE__*/React.createElement("img", {
    src: src || '',
    alt: alt,
    height: ICON_SIZE,
    width: ICON_SIZE,
    style: {
      borderRadius: ICON_SIZE / 2
    }
  });
}
export function Buggy() {
  useEffect(() => {
    throw new Error('Something wrong inside People menu.');
  });
  return null;
}
export const fireRenderPeopleNavMenuFail = error => {
  renderPeopleNavMenuExp.failure({
    metadata: {
      ...(error && 'status' in error ? {
        status: error.status
      } : {}),
      ...(error instanceof ErrorWithContext ? {
        context: error.context
      } : {}),
      error: error === null || error === void 0 ? void 0 : error.message
    }
  });
};